export default __webpack_public_path__ + "static/media/MD.9ba8d830.svg";